import VideoBackground from 'components/video-background'
import { F1_BADGE_VIDEO } from '../constants'

// Badge video block (Figma 5595:12187): full-bleed looping spot of the F1
// lanyard badges. The design shows the footage itself as the only content;
// no dedicated poster still was delivered to the CDN.
const BadgeVideoSection = () => {
  return (
    <section className="pitstops__video">
      <VideoBackground className="pitstops__video-media" src={F1_BADGE_VIDEO} />
    </section>
  )
}

export default BadgeVideoSection
